import { useEffect } from 'react';

import { popSystemBarsOverlay, pushSystemBarsOverlay, SystemBarColors } from '../utils/nativeSystemBars';

const useSystemBarsOverlay = (isActive: boolean, colors: SystemBarColors): void => {
  const { statusBar, navigationBar } = colors;

  useEffect(() => {
    if (!isActive) return undefined;

    pushSystemBarsOverlay({ statusBar, navigationBar });

    return () => popSystemBarsOverlay();
  }, [isActive, statusBar, navigationBar]);
};

export default useSystemBarsOverlay;
